import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { useEffect, useState, useRef } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';



function copyToClipboard(text, id, setCopiedId) {
	navigator.clipboard.writeText(text).then(() => {
		setCopiedId(id);
		setTimeout(() => setCopiedId(null), 1000); // skry po 2 sekundách
	});
}


function getFileExtension(url) {
	try {
		const pathname = new URL(url).pathname;
		const parts = pathname.split('.');
		return parts.length > 1 ? parts.pop().toUpperCase() : '';
	} catch {
		return '';
	}
}

const Lightbox = ({ items, currentIndex, onClose, onPrev, onNext, showTitle,autoplay }) => {
	const current = items[currentIndex];
	const [loaded, setLoaded] = useState(false);
	const [touchStartX, setTouchStartX] = useState(null);
const [touchEndX, setTouchEndX] = useState(null);
const [isAutoplay, setIsAutoplay] = useState(autoplay);
const [isLoop, setIsLoop] = useState(false); // môžeme neskôr preposielať z globálnych props

useEffect(() => {
	if (!isAutoplay || !current) return;

	let timeout;
	const selector = '.mediashelf-lightbox-content video, .mediashelf-lightbox-content audio';

	// VIDEO / AUDIO – autoplay + prípadne loop
	if (current.type === 'video' || current.type === 'audio') {
		const mediaEl = document.querySelector(selector);

		if (mediaEl) {
			// nastav HTML atribút loop len ak je zapnutý
			mediaEl.loop = isLoop;

			// ak nie je loop, po skončení ide na ďalší
			const handleEnded = () => {
				if (!isLoop) {
					onNext();
				}
			};

			mediaEl.addEventListener('ended', handleEnded);

			return () => {
				mediaEl.removeEventListener('ended', handleEnded);
			};
		}
	}

	// Obrázky: len autoplay (loop ignorujeme, lebo sa znovu nezobrazujú rovnaké)
	else if (current.type === 'image') {
		timeout = setTimeout(() => {
			onNext();
		}, 5000); // trvanie obrázka

		return () => clearTimeout(timeout);
	}
}, [currentIndex, isAutoplay, isLoop]);



useEffect(() => {
	function handleKeyDown(e) {
		if (e.key === 'ArrowLeft') {
			onPrev();
		} else if (e.key === 'ArrowRight') {
			onNext();
		} else if (e.key === 'Escape') {
			onClose();
		}
	}

	document.addEventListener('keydown', handleKeyDown);

	return () => {
		document.removeEventListener('keydown', handleKeyDown);
	};
}, [onPrev, onNext, onClose]);

const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
const handleTouchMove = (e) => setTouchEndX(e.touches[0].clientX);
const handleTouchEnd = () => {
	if (!touchStartX || !touchEndX) return;
	const distance = touchStartX - touchEndX;

	if (distance > 50) onNext();     // swipe left
	if (distance < -50) onPrev();    // swipe right

	setTouchStartX(null);
	setTouchEndX(null);
};

	useEffect(() => {
		setLoaded(false);
	}, [currentIndex]);

	if (!current) return null;

	const handleMediaLoad = () => setLoaded(true);

	return (
		<div className="mediashelf-lightbox" onClick={onClose}>
			<div
	className={`mediashelf-lightbox-content ${loaded ? 'loaded' : ''}`}
	onClick={(e) => e.stopPropagation()}
	onTouchStart={handleTouchStart}
	onTouchMove={handleTouchMove}
	onTouchEnd={handleTouchEnd}
>
				{current.type === 'image' && (
					<img src={current.src} alt="" onLoad={handleMediaLoad} />
				)}
				{current.type === 'video' && (
					<video src={current.src} controls autoPlay onCanPlay={handleMediaLoad} />
				)}
				{current.type === 'audio' && (
					<div className="mediashelf-audio-wrapper">
						<audio src={current.src} controls autoPlay style={{ width: '100%' }} onCanPlay={handleMediaLoad} />
					</div>
				)}
				{showTitle && (
		<div className="mediashelf-lightbox-title">
			{current?.title}
		</div>
	)}
			</div>
			<div className="mediashelf-lightbox-controls" onClick={(e) => e.stopPropagation()}>
			<button
    className={`mediashelf-lightbox-toggle ${isAutoplay ? 'active' : ''}`}
    title="Toggle Autoplay"
    onClick={() => setIsAutoplay((prev) => !prev)}
  >
    <span className="dashicons dashicons-controls-play"></span>
  </button>

  {/* 🔁 Loop toggle */}
  <button
    className={`mediashelf-lightbox-toggle ${isLoop ? 'active' : ''}`}
    title="Toggle Loop"
    onClick={() => setIsLoop((prev) => !prev)}
  >
    <span className="dashicons dashicons-update"></span>
  </button>
			<button className="mediashelf-lightbox-prev" onClick={onPrev}>
	<span className="dashicons dashicons-arrow-left-alt2"></span>
</button>
<button className="mediashelf-lightbox-next" onClick={onNext}>
	<span className="dashicons dashicons-arrow-right-alt2"></span>
</button>
				<button className="mediashelf-lightbox-close" onClick={onClose}><span className="dashicons dashicons-no-alt"></span></button>
			</div>
		</div>
	);
};

const MediaShelfFrontend = ({ autoplay,category, protected: isProtected, password, cachePassword,dateFilter,hideButtons, showTitle,hideFileExtension,hideDownload,hideCopy,hideDateFilter,hideTypeFilter,loadingText,unlockText,lockedText,wrongPasswordText,passwordPlaceholderText,loadMoreLoadingText,loadMoreButtonText,columnsTablet,columnsMobile,columnsDesktop,copied,nomedia,hideCategoryFilter,openLightbox,onlyLoggedIn,fullImagePreview,showWpTitleInLightbox,showDateYear,showFileSize }) => {

	if (onlyLoggedIn && !window.mediashelfData?.isLoggedIn) {
		return (
			<p style={{ textAlign: 'center', padding: '20px' }}>
				🔒 Please log in to view this content.
			</p>
		);
	}


	const [mediaItems, setMediaItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [inputPassword, setInputPassword] = useState('');
	const [isUnlocked, setIsUnlocked] = useState(false);
	const [lightboxIndex, setLightboxIndex] = useState(null);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [copiedId, setCopiedId] = useState(null);
	const loadMoreRef = useRef(null);
	const [dateOptions, setDateOptions] = useState([]);
	const [selectedDateFilter, setSelectedDateFilter] = React.useState(dateFilter || '');
	const [selectedTypeFilter, setSelectedTypeFilter] = React.useState('');
	const [categories, setCategories] = useState([]);
const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(category || '');

const isPro = typeof window !== 'undefined' && window.mediashelfData?.isPro;

	const getItemWidth = () => {
		const width = window.innerWidth;
		if (width <= 768) {
		  return `calc(${100 / (columnsMobile || 2)}% - 16px)`;
		} else if (width <= 1024) {
		  return `calc(${100 / (columnsTablet || 3)}% - 16px)`;
		}
		return `calc(${100 / (columnsDesktop || 4)}% - 16px)`;
	  };

    useEffect(() => {
		const fetchDates = async () => {
			try {
				const options = await apiFetch({ path: '/mediashelf/v1/dates' });
				setDateOptions(options || []);
			} catch (err) {
				console.error('Chyba pri načítaní dátumov:', err);
			}
		};
		fetchDates();
	}, []);

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const response = await apiFetch({ path: '/wp/v2/media_category?per_page=100' });
				setCategories(response || []);
			} catch (err) {
				console.error('Chyba pri načítaní kategórií:', err);
			}
		};
		fetchCategories();
	}, []);
	

	useEffect(() => {
		if (!hasMore || loading) return; // Neaktivuj ak niet čo načítať alebo ak sa už načítava
	
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					setPage((prev) => prev + 1);
					setLoading(true);
				}
			},
			{
				rootMargin: '200px', // môžeš pridať buffer, načíta skôr než je presne vo viewporte
			}
		);
	
		if (loadMoreRef.current) {
			observer.observe(loadMoreRef.current);
		}
	
		return () => {
			if (loadMoreRef.current) {
				observer.unobserve(loadMoreRef.current);
			}
		};
	}, [hasMore, loading]);
	



	useEffect(() => {
		if (lightboxIndex !== null) {
			document.body.classList.add('mediashelf-lightbox-open');
			document.documentElement.classList.add('mediashelf-lightbox-open');
		} else {
			document.body.classList.remove('mediashelf-lightbox-open');
			document.documentElement.classList.remove('mediashelf-lightbox-open');
		}
		
	}, [lightboxIndex]);

	useEffect(() => {
		if (isProtected && !isUnlocked) {
			const cached = localStorage.getItem(`mediashelf-pass-${password}`);
			if (cached === password) {
				setIsUnlocked(true);
			}
		}
	}, []);

	useEffect(() => {
		if (isProtected && !isUnlocked) return;

		const fetchMedia = async () => {
			try {
				const params = {
					per_page: 100,
					page,
					orderby: 'date',
					order: 'desc',
				};
		
				if (selectedCategoryFilter) {
					params.media_category = selectedCategoryFilter;
				} else if (category && category !== 0) {
					params.media_category = category;
				}
		
				if (selectedDateFilter || dateFilter) {
					const [year, month] = (selectedDateFilter || dateFilter).split('-');
					const monthInt = parseInt(month, 10);
					const after = new Date(year, monthInt - 1, 1).toISOString();
					const before = new Date(year, monthInt, 1).toISOString();
					params.after = after;
					params.before = before;
				}
				if (selectedTypeFilter && selectedTypeFilter !== 'file') {
					params.media_type = selectedTypeFilter;
				}
		
				const query = new URLSearchParams(params).toString();
				
				const response = await apiFetch({
					path: `/wp/v2/media?${query}`,
					parse: false,
				});
		
				const items = await response.json();
				const totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);

				

		
				setMediaItems((prev) => [...prev, ...items]);    
				setHasMore(page < totalPages);
			} catch (err) {
				console.error('Chyba pri načítaní médií:', err);
			} finally {
				setLoading(false);
			}
		};

		fetchMedia();
	}, [category, isUnlocked, page, selectedDateFilter, selectedTypeFilter,selectedCategoryFilter]);   

	if (isProtected && !isUnlocked) {
		return (
			<div className="mediashelf-locked">
				<p>🔒 {lockedText || 'Password Protected'}</p>
				<input
					type="password"
					placeholder={passwordPlaceholderText || 'Zadajte heslo'}
					value={inputPassword}
					onChange={(e) => setInputPassword(e.target.value)}
					style={{
						padding: '10px',
						fontSize: '16px',
						width: '100%',
						boxSizing: 'border-box',
						marginBottom: '10px',
					  }}
				/>
				<button
  onClick={() => {
    if (inputPassword === password) {
      if (cachePassword) {
        localStorage.setItem(`mediashelf-pass-${password}`, password);
      }
      setIsUnlocked(true);
    } else {
      localStorage.removeItem(`mediashelf-pass-${password}`);
    }
  }}
  style={{
    padding: '10px',
    fontSize: '16px',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    color: 'black',
    border: 'none',
    borderRadius: '4px',
    marginBottom: '10px',
  }}
>
{unlockText || 'Unlock Data'}
</button>
				{inputPassword && inputPassword !== password && (
					<p style={{ color: 'red' }}>{wrongPasswordText || '❌ Wrong Password'}</p>
				)}
			</div>
		);
	}

	

	const lightboxItems = mediaItems
		.map((item) => {
			let type = item.media_type;
			if (type !== 'image' && type !== 'video') {
				if (item.mime_type.startsWith('audio/')) {
					type = 'audio';
				} else if (item.mime_type.startsWith('video/')) {
					type = 'video';
				} else {
					type = 'file';
				}
			}
			return { id: item.id, src: item.source_url, type, title: item.title?.rendered || ''  };
		})
		.filter((item) => item.type === 'image' || item.type === 'video' || item.type === 'audio');

		const isFiltersLoaded = dateOptions.length > 0 && categories.length > 0;

	return (
		<>
		{/* Filtre - vždy viditeľné */}
		
		{(!hideDateFilter || !hideTypeFilter) && (
		  <div className={`mediashelf-date-filter ${isFiltersLoaded ? 'is-loaded' : ''}`} style={{ marginBottom: '20px' }}>
			{!hideDateFilter && (
			  <select
				value={selectedDateFilter}
				onChange={(e) => {
				  setPage(1);
				  setMediaItems([]);
				  setLoading(true);
				  setSelectedDateFilter(e.target.value);
				}}
				style={{ padding: '10px', fontSize: '16px', margin: '10px' }}
			  >
				{(dateOptions || []).map((opt) => (
				  <option key={opt.value} value={opt.value}>
					{opt.label}
				  </option>
				))}
			  </select>
			)}


{!hideCategoryFilter && categories.length > 0 && (
  <select
    value={selectedCategoryFilter}
    onChange={(e) => {
      setPage(1);
      setMediaItems([]);
      setLoading(true);
      setSelectedCategoryFilter(e.target.value);
    }}
    style={{ padding: '10px', fontSize: '16px', margin: '10px' }}
  >
    <option value="">Category</option>
    {categories.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {cat.name}
      </option>
    ))}
  </select>
)}


			{!hideTypeFilter && (
			  <select
				value={selectedTypeFilter}
				onChange={(e) => {
				  setPage(1);
				  setMediaItems([]);
				  setLoading(true);
				  setSelectedTypeFilter(e.target.value);
				}}
				style={{ padding: '10px', fontSize: '16px', margin: '10px' }}
			  >
				<option value="">Type</option>
				<option value="image">🖼️ Image</option>
				<option value="video">🎞️ Video</option>
				<option value="audio">🎵 Audio</option>
				<option value="file">📄 File</option>
			  </select>
			)}
		  </div>
		)}
	  
		{/* Loading text */}
		{loading && mediaItems.length === 0 && (
		  <p style={{ textAlign: 'center', padding: '20px 0', fontSize: '18px', color: '#7d7d7d' }}>
			{loadingText || 'Loading Data...'}
		  </p>
		)}
	  
		{/* No media text */}
		{!loading && mediaItems.length === 0 && (
		  <p style={{ textAlign: 'center', padding: '20px 0', fontSize: '18px' }}>
			✅ {nomedia || 'No media to display...'}
		  </p>
		)}
	  
		{/* Grid */}
		{mediaItems.length > 0 && (
		 <>
		 {Object.entries(
		   mediaItems.reduce((acc, item) => {
			 const d = new Date(item.date);
			 const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
			 if (!acc[key]) acc[key] = [];
			 acc[key].push(item);
			 return acc;
		   }, {})
		 ).map(([dateKey, items]) => (
		   <div key={dateKey} className="mediashelf-date-group">
			{showDateYear && (
			 <p className="mediashelf-date-heading">📅{formatMonthYear(dateKey)}</p>
			 )}
	   
			 <div className="mediashelf-grid">
			   {items
				 .filter((item) => {
				   let type = item.media_type;
				   if (type !== 'image' && type !== 'video') {
					 if (item.mime_type.startsWith('audio/')) {
					   type = 'audio';
					 } else if (item.mime_type.startsWith('video/')) {
					   type = 'video';
					 } else {
					   type = 'file';
					 }
				   }
	   
				   if (selectedTypeFilter) {
					 if (
					   selectedTypeFilter === 'file' &&
					   (type === 'image' || type === 'video' || type === 'audio')
					 ) {
					   return false;
					 }
					 if (selectedTypeFilter !== 'file' && type !== selectedTypeFilter) {
					   return false;
					 }
				   }
	   
				   return true;
				 })
				 .map((item) => {
				   let type = item.media_type;
				   const src = item.source_url;
				   const thumbSrc = (() => {
					 if (type !== 'image') return src;
	   
					 const sizes = item.media_details?.sizes;
					 if (!sizes) return src;
	   
					 if (fullImagePreview) {
					   if (sizes.full) return sizes.full.source_url;
					   if (sizes.large) return sizes.large.source_url;
					   if (sizes.medium) return sizes.medium.source_url;
					 }
	   
					 if (sizes.medium) return sizes.medium.source_url;
	   
					 return src;
				   })();
	   
				   if (type !== 'image' && type !== 'video') {
					 if (item.mime_type.startsWith('audio/')) {
					   type = 'audio';
					 } else if (item.mime_type.startsWith('video/')) {
					   type = 'video';
					 } else {
					   type = 'file';
					 }
				   }
	   
				   return (
					 <div
					   className="mediashelf-item"
					   key={item.id}
					   style={{
						 flex: `1 1 ${getItemWidth()}`,
						 maxWidth: getItemWidth(),
					   }}
					   onClick={(e) => {
						 if (e.target.closest('a')) return;
						 if (!isPro) return; // PRO ochrana – potichu zablokuj
						 if (type === 'image' || type === 'video' || type === 'audio') {
						   const index = lightboxItems.findIndex((m) => m.id === item.id);
						   setLightboxIndex(index);
						 }
					   }}
					 >
					   {type === 'image' ? (
						 <div
						   className="mediashelf-file-wrapper"
						   style={{
							 display: 'flex',
							 flexDirection: 'column',
							 justifyContent: 'space-between',
							 alignItems: 'center',
							 height: '100%',
						   }}
						 >
						   {copiedId === item.id && (
							 <div style={{ fontSize: '12px', color: 'green', marginTop: '4px' }}>
							   {copied || '✅ Link Copied to clipboard'}
							 </div>
						   )}
						   <img
							 src={thumbSrc}
							 style={{ objectFit: 'cover', width: '100%', height: '100%' }}
							 alt={item.alt_text || ''}
						   />
						   {!hideButtons && (
							 <div className="mediashelf-extension">
							   {!hideDownload && (
								 <a
								   href={src}
								   download
								   title="Stiahnuť"
								   style={{ textDecoration: 'none', marginRight: '5px' }}
								 >
								   ⬇️
								 </a>
							   )}
							   {!hideCopy && (
								 <button
								   onClick={(e) => {
									 e.stopPropagation();
									 copyToClipboard(src, item.id, setCopiedId);
								   }}
								   title="Copy Link"
								   style={{
									 border: 'none',
									 background: 'transparent',
									 cursor: 'pointer',
									 fontSize: '16px',
									 padding: 0,
								   }}
								 >
								   📎
								 </button>
							   )}
							   {!hideFileExtension && <>🖼️ {getFileExtension(src)}</>}

							   {!showFileSize && <>
							 
							   {item.filesize_human && (
  <span style={{ marginLeft: '5px', fontSize: '12px', color: 'white' }}>
    {item.filesize_human}
  </span>
)}</>}
							 </div>
						   )}
						 </div>
					   ) : (
						 <div
						   className="mediashelf-file-wrapper"
						   style={{
							 display: 'flex',
							 flexDirection: 'column',
							 justifyContent: 'space-around',
							 alignItems: 'center',
							 height: '100%',
						   }}
						 >
						   {copiedId === item.id && (
							 <div style={{ fontSize: '12px', color: 'green', marginTop: '4px' }}>
							   {copied || '✅ Link Copied'}
							 </div>
						   )}
						   <div className="mediashelf-file" style={{ textAlign: 'center' }}>
							 {item.title.rendered}
						   </div>
						   {!hideButtons && (
							 <div className="mediashelf-extension">
							   {!hideDownload && (
								 <a
								   href={src}
								   download
								   title="Stiahnuť"
								   style={{ textDecoration: 'none', marginRight: '5px' }}
								 >
								   ⬇️
								 </a>
							   )}
							   {!hideCopy && (
								 <button
								   onClick={(e) => {
									 e.stopPropagation();
									 copyToClipboard(src, item.id, setCopiedId);
								   }}
								   title="Kopírovať odkaz"
								   style={{
									 border: 'none',
									 background: 'transparent',
									 cursor: 'pointer',
									 fontSize: '16px',
									 padding: 0,
								   }}
								 >
								   📎
								 </button>
							   )}
							   {!hideFileExtension && (
								 <>
								   {type === 'video' && <>🎞️ {getFileExtension(src)}</>}
								   {type === 'audio' && <>🎵 {getFileExtension(src)}</>}
								   {type === 'file' && <>📄 {getFileExtension(src)}</>}
								 </>
							   )}
							   {!showFileSize && <>
							 
							 {item.filesize_human && (
<span style={{ marginLeft: '5px', fontSize: '12px', color: 'white' }}>
  {item.filesize_human}
</span>
)}</>}
							 </div>
						   )}
						 </div>
					   )}
					 </div>
				   );
				 })}
			 </div>
		   </div>
		 ))}
	   
		 {/* Load More Button */}
		 {hasMore && (
		   <div style={{ textAlign: 'center', marginTop: '20px' }}>
			 <button
			   ref={loadMoreRef}
			   onClick={() => {
				 setPage((prev) => prev + 1);
				 setLoading(true);
			   }}
			   disabled={loading}
			   style={{
				 opacity: loading ? 0.6 : 1,
				 cursor: loading ? 'not-allowed' : 'pointer',
			   }}
			 >
			   {loading ? loadMoreLoadingText || '⏳ loading...' : loadMoreButtonText || 'Load More'}
			 </button>
		   </div>
		 )}
	   </>
	   
		)}
	  
		{/* Lightbox */}
		{lightboxIndex !== null && isPro && (
  <Lightbox
    items={lightboxItems}
    currentIndex={lightboxIndex}
    onClose={() => setLightboxIndex(null)}
    onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : lightboxItems.length - 1))}
    onNext={() => setLightboxIndex((prev) => (prev < lightboxItems.length - 1 ? prev + 1 : 0))}
    showTitle={showTitle}
    showWpTitle={showWpTitleInLightbox}
	autoplay={autoplay}
  />
)}
	  </>
	  
	
	);
};

function formatMonthYear(dateStr) {
	const [year, month] = dateStr.split("-");
	const d = new Date(year, month - 1);
	return d.toLocaleString("default", { month: "long", year: "numeric" }); 
  }


function initializeMediashelf() {
	
	const elements = document.querySelectorAll('.wp-block-create-block-mediashelf:not(.initialized)');
	
	elements.forEach((el) => {
		const data = JSON.parse(el.dataset.attrs || '{}');
		const encodedPassword = el.dataset.password || '';
		data.password = encodedPassword ? atob(encodedPassword) : '';

		const root = createRoot(el);
		root.render(<MediaShelfFrontend {...data} />);
		el.classList.add('initialized');
	});
}

document.addEventListener('DOMContentLoaded', initializeMediashelf);
